import React from 'react';
import { TTextTranslationNamespaces } from 'types';
import { Radio } from 'antd';
import Text from 'components/Text/Text';
import style from './SegmentedSwitch.module.scss';

interface IProps<T extends string> {
	value: T;
	options: { value: T; translationKey: string }[];
	translationNameSpace?: TTextTranslationNamespaces;
	testId?: string;
	onChange: (value: T) => void;
}

export const SegmentedSwitch = <T extends string>({
	value,
	options,
	translationNameSpace,
	testId,
	onChange,
}: IProps<T>) => (
	<Radio.Group className={style.container} value={value} data-test={testId}>
		{options.map((el) => (
			<Radio.Button key={el.value} value={el.value} onChange={() => onChange(el.value)}>
				<Text
					translationNameSpace={translationNameSpace}
					translationKey={el.translationKey}
					asFragment={true}
				/>
			</Radio.Button>
		))}
	</Radio.Group>
);
